export class SearchSuggestionRequest {
    public searchPhrase: string;
    public searchType: number;
    public resultsPerPage: number;
}
